export default "__VITE_ASSET__DQpnLhBK__"